import * as React from 'react';

import { ErrorMsg } from '../';
import { addModifiers } from '../../../shared/helpers';

import './Textarea.scss';

interface TextareaProps {
  name: string;
  label?: string | null;
  value?: string;
  handleChange: (event: any, options?: any) => void;
  modifiers?: string[];
  contentModifiers?: string[];
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  id?: string;
  handleOptions?: any;
  errors?: any[];
  labelModifiers?: string[];
  tabindex?: number;
}

class Textarea extends React.Component<TextareaProps> {
  handleChange = (event: any) => {
    this.props.handleChange(event, this.props.handleOptions);
  };

  componentDidMount() {
    const event = {
      target: {
        type: 'textearea',
        value: this.props.value,
        name: this.props.name,
      },
    };

    this.props.handleChange(event, this.props.handleOptions);
  }
  render() {
    const {
      name,
      label = null,
      errors = [],
      value = '',
      id,
      modifiers = [],
      contentModifiers = [],
      disabled = false,
      required = false,
      placeholder = '',
      labelModifiers = [],
      tabindex = 0,
    } = this.props;

    return (
      <div className={addModifiers('textarea__content', contentModifiers)}>
        {label && (
          <label htmlFor={id} className={addModifiers('textarea__label', labelModifiers)}>
            {label}
            {required && <sup className="textarea__sup">*</sup>}
          </label>
        )}
        <textarea
          name={name}
          defaultValue={value}
          disabled={disabled}
          id={id}
          onChange={this.handleChange}
          className={addModifiers('textarea__elem', modifiers)}
          placeholder={placeholder}
          tabIndex={tabindex}
        />

        <div className="textarea__error">{errors.length !== 0 && <ErrorMsg errors={errors} />}</div>
      </div>
    );
  }
}
export default Textarea;
